import NavBar from "../../../layout/navBar/NavBar";
import SideBar from "../../../layout/sideBar/SideBar";
import { makeStyles } from "@material-ui/core/styles";
import LinkHistoryArticle from "./LinkHistoryArticle";
import useValidateJwt from "../../../hooks/useValidateJwt";
import Loading from "../../../components/globalUtils/Loading";
import { usePromiseTracker } from "react-promise-tracker";

const LinkHistory = () => {
  const mouseDownHandler = useValidateJwt();
  const { promiseInProgress } = usePromiseTracker();
  const styles = makeStyles((theme) => ({
    offset: theme.mixins.toolbar,
    content: {
      padding: theme.spacing(3),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
    },
  }));

  const style11 = styles();

  return (
    <div onMouseDown={mouseDownHandler} style={{ display: "flex" }}>
      <NavBar route={"Historial de links"} />
      <SideBar />
      <div className={style11.content}>
        <div className={style11.offset}></div>

        <div
          style={{
            width: "100%",
            height: "80vh",
            position: "relative",
            top: "40px",
          }}
        >
          <LinkHistoryArticle />
        </div>
      </div>
      {promiseInProgress === true ? <Loading /> : null}
    </div>
  );
};

export default LinkHistory;
